import { ThemeOptions } from '@mui/material';

export const alertThemeOptions: ThemeOptions = {
  components: {
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontWeight: 700,
          lineHeight: '1.3125rem',
        },
      },
    },
  },
};
